const cards = [
  {
    id: 1,
    title: '狂飙：扫黑除恶的荧屏巅峰之作',
    desc: '张译与张颂文的对手戏堪称教科书级别，从菜市场鱼贩到黑道大佬，高启强的命运沉浮让人唏嘘不已。全剧节奏紧凑、人物立体，是近年国产刑侦剧的里程碑。',
    tag: '刑侦 · 9.8分',
    img: 'https://readdy.ai/api/search-image?query=Moody%20noir%20cityscape%20at%20night%2C%20rain%20on%20asphalt%2C%20warm%20street%20lamp%20glow%2C%20silhouette%20of%20two%20men%20in%20confrontation%2C%20cinematic%20lighting%2C%20amber%20and%20dark%20shadow%20contrast%2C%20film%20grain%20aesthetic&width=700&height=460&seq=cards-01&orientation=landscape'
  },
  {
    id: 2,
    title: '繁花：王家卫镜头下的上海往事',
    desc: '九十年代上海的商海浮沉与人间烟火，王家卫耗时三年打磨的电视剧处女作，胡歌领衔的全明星阵容演绎了一出繁华落尽的时代悲喜剧。',
    tag: '年代 · 9.7分',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20Shanghai%20street%20at%20golden%20hour%2C%20art%20deco%20buildings%2C%20neon%20signs%20glowing%2C%20wet%20cobblestone%2C%20nostalgic%20atmosphere%2C%20warm%20sepia%20tones%2C%20cinematic%20composition&width=700&height=460&seq=cards-02&orientation=landscape'
  },
  {
    id: 3,
    title: '庆余年第二季：权谋再升级',
    desc: '范闲假死归来，京都朝堂暗流涌动。第二季在原班人马基础上加入更多实力派演员，权谋线更加复杂，笑点与泪点并存，堪称古装权谋剧新标杆。',
    tag: '古装 · 9.6分',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20warm%20candlelight%2C%20ornate%20wooden%20pillars%2C%20figure%20in%20traditional%20silk%20robe%2C%20dramatic%20shadows%2C%20cinematic%20lighting%2C%20amber%20and%20deep%20red%20tones&width=700&height=460&seq=cards-03&orientation=landscape'
  },
  {
    id: 4,
    title: '长相思：上古虐恋引爆暑期档',
    desc: '杨紫领衔的上古神话虐恋史诗，清水镇到轩辕国的漫长旅程，相柳与小夭跨越生死的深情令人动容。特效精良，服化道考究，是今年仙侠剧的口碑之作。',
    tag: '仙侠 · 9.5分',
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20fantasy%20landscape%20with%20cherry%20blossoms%20floating%2C%20ancient%20bridge%20over%20misty%20water%2C%20soft%20peach%20and%20gold%20light%2C%20dreamy%20atmosphere%2C%20romantic%20cinematic%20scene&width=700&height=460&seq=cards-04&orientation=landscape'
  },
  {
    id: 5,
    title: '三体：中国科幻的里程碑之作',
    desc: '根据刘慈欣同名小说改编，用宏大的叙事呈现了人类文明与三体世界的首次接触。从红岸基地到古筝行动，视觉奇观与哲学思辨并重，开启了国产科幻剧新纪元。',
    tag: '科幻 · 9.3分',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20observatory%20dome%20under%20starry%20night%20sky%2C%20cosmic%20glow%2C%20radio%20telescope%20silhouette%2C%20deep%20space%20aesthetic%2C%20warm%20golden%20light%20against%20dark%20universe%2C%20cinematic%20sci-fi%20atmosphere&width=700&height=460&seq=cards-05&orientation=landscape'
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            编辑团队精心甄选，每一部都是不可错过的佳作
          </p>
        </div>

        <div className="flex flex-col gap-5 md:gap-6">
          {cards.map((card) => (
            <div
              key={card.id}
              className="flex flex-col sm:flex-row gap-4 md:gap-6 bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-accent-300/40 transition-colors cursor-pointer"
            >
              <div className="w-full sm:w-48 md:w-56 flex-shrink-0">
                <div className="aspect-[3/2] rounded-lg overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-center">
                <span className="inline-block px-2 py-0.5 bg-accent-50 text-accent-700 text-xs rounded-full w-fit mb-2">
                  {card.tag}
                </span>
                <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-2">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}